import { createRouter, createWebHistory } from "vue-router";
import MainComponent from "../views/user/home.vue";
import adminpanel from "../views/admin/adminpanel.vue";
import slots from "../views/admin/slots.vue";
import data from "../views/admin/data.vue";

const routes = [
  {
    path:'/',
    name:'MainComponent',
    component:MainComponent
  },
  {
    path:"/Home",
    name:"Home",
    component:MainComponent
  },
  {
    path: '/adminpanel',
    name: "adminpanel",
    component: adminpanel,
  },
  {
    path: '/adminpanel/slots',
    name: "slots",
    component: slots,
    meta: { requiresAuth: true }
  },
  {
    path: '/adminpanel/data',
    name: "data",
    component: data,
    meta: { requiresAuth: true }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true';
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    // Save the intended destination
    sessionStorage.setItem('intendedRoute', to.fullPath);
    // Redirect to login
    next('/adminpanel');
  } else {
    next();
  }
});

export default router;
